'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { IconLoader } from '../../svg/icons/icon-loader.js';

const UserLoadingIndicator = ({ className, iconClassName, text, }) => (jsxs("div", { className: `flex size-full flex-col items-center justify-center p-2 ${className}`, children: [jsx(IconLoader, { className: `animate-spin ${iconClassName}` }), text ? jsx("h2", { className: "mt-8 text-2xl", children: text }) : null] }));

export { UserLoadingIndicator };
//# sourceMappingURL=user-loading-indicator.js.map
